import {baseApi} from 'core/redux/store/api';
import {
    IClearWishlistData,
    IDeleteProductData,
    IReserveProductData,
    ISharedWishlistData,
    IUserWishlistData,
    IWishlistProductShort,
    TAddToWishListResponse,
} from 'modules/wishlist_new/models';

const API_VERSION = 'platform/api/v2';

export const wishListApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getUserWishlist: builder.query<IUserWishlistData, void>({
            providesTags: ['WishlistNew'],
            query: () => `${API_VERSION}/wishlist`,
        }),

        addProductToWishlist: builder.mutation<TAddToWishListResponse, {article?: IWishlistProductShort['id']}>({
            invalidatesTags: ['WishlistNew'],
            query: ({article}) => ({
                body: {
                    article,
                },
                method: 'POST',
                url: `${API_VERSION}/wishlist/items`,
            }),
        }),

        deleteProductFromWishlist: builder.mutation<
            IDeleteProductData,
            {
                wishlistId: IUserWishlistData['meta']['wishlistId'];
                article: IWishlistProductShort['id'];
            }
        >({
            invalidatesTags: ['WishlistNew'],
            query: ({wishlistId, article}) => ({
                method: 'DELETE',
                url: `${API_VERSION}/wishlist/${wishlistId}/items/${article}`,
                body: {},
            }),
        }),

        clearWishlist: builder.mutation<IClearWishlistData, {wishlistId?: number}>({
            invalidatesTags: ['WishlistNew'],
            query: ({wishlistId}) => ({
                method: 'DELETE',
                url: `${API_VERSION}/wishlist/${wishlistId}/items`,
                body: {},
            }),
        }),

        getSharedWishlist: builder.query<ISharedWishlistData, {shareKey?: string}>({
            providesTags: ['WishlistNew'],
            query: ({shareKey}) => `${API_VERSION}/wishlist/share/${shareKey}`,
        }),

        reserveWishlistProduct: builder.mutation<
            IReserveProductData,
            {
                wishlistId: ISharedWishlistData['meta']['wishlistId'];
                article?: string;
            }
        >({
            invalidatesTags: ['WishlistNew'],
            query: ({wishlistId, article}) => ({
                method: 'PATCH',
                url: `${API_VERSION}/wishlist/${wishlistId}/items/${article}/reserve`,
                body: {},
            }),
        }),
    }),
});

export const {
    useGetUserWishlistQuery,
    useAddProductToWishlistMutation,
    useDeleteProductFromWishlistMutation,
    useClearWishlistMutation,
    useGetSharedWishlistQuery,
    useReserveWishlistProductMutation,
} = wishListApiService;
